import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { goodsStatement } from "../../../api/data";
import VxeTable from "@/components/vxeTable/vxeTable.vue";
import serverList from "../../../components/serverList/serverOptions.vue";
import vipOptions from "../../../components/serverList/vipOptions.vue";
import GoodsOptions from "../../../components/serverList/goodsOptions.vue";
import DataOptions from "../../../components/timeList/dataOptions.vue";
import { getGameGoodsMap, getReasonMap } from "@/utils/dictionary";
import exportCsv from "@/mixins/exportCsv";
export default {
  components: {
    serverList: serverList,
    vipOptions: vipOptions,
    GoodsOptions: GoodsOptions,
    VxeTable: VxeTable,
    DataOptions: DataOptions
  },
  name: "currencyAnalysis",
  mixins: [exportCsv],
  data: function data() {
    var _this = this;
    var h = this.$createElement;
    return {
      gameGoodsList: {},
      goodsArray: [],
      reasonArray: [],
      options: [{
        value: 0,
        label: "全部"
      }, {
        value: 1,
        label: "产出"
      }, {
        value: 2,
        label: "消耗"
      }],
      // optionLabel: "",
      value: "",
      searchInfo: {
        statement_type: 1,
        server_id: [],
        vip_levels: []
      },
      timedata: [this.$moment().subtract(1, "days").format("YYYY-MM-DD"), this.$moment().subtract(1, "days").format("YYYY-MM-DD")],
      tableData: [],
      tableDataCount: {},
      tableColumn: [{
        field: "date_str",
        title: "日期",
        sortable: true
      }, {
        field: "server_id",
        title: "服务器id",
        sortable: true
      }, {
        field: "statement_type",
        title: "操作类型",
        sortable: true,
        slots: {
          default: function _default(_ref) {
            var row = _ref.row;
            return [h("span", [row.statement_type == 1 ? "产出" : "消耗"])];
          }
        }
      }, {
        field: "goods_id",
        title: "道具",
        sortable: true,
        slots: {
          default: function _default(_ref2) {
            var row = _ref2.row;
            return [h("span", [_this.gameGoodsList[row.goods_id], "(", row.goods_id, ")"])];
          }
        }
      }, {
        field: "reason_name",
        title: "操作内容",
        sortable: true
      }, {
        field: "role_vip_level",
        title: "vip等级",
        sortable: true
      }, {
        field: "operation_role_cnt",
        title: "操作人数",
        sortable: true
      }, {
        field: "operation_cnt",
        title: "操作次数",
        sortable: true
      }, {
        field: "cnt",
        title: "道具总数",
        sortable: true
      }, {
        field: "cnt_avg",
        title: "人均",
        sortable: true
      }, {
        field: "percent",
        title: "道具占比",
        sortable: true,
        slots: {
          default: function _default(_ref3) {
            var row = _ref3.row;
            return [h("span", [row.percent, "%"])];
          }
        }
      }]
    };
  },
  mounted: function mounted() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.init();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var index, reasonList, _index;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getGameGoodsMap();
            case 2:
              _this3.gameGoodsList = _context2.sent;
              for (index in _this3.gameGoodsList) {
                _this3.goodsArray.push({
                  goodsId: index,
                  goodsName: _this3.gameGoodsList[index]
                });
              }
              _context2.next = 6;
              return getReasonMap();
            case 6:
              reasonList = _context2.sent;
              for (_index in reasonList) {
                _this3.reasonArray.push({
                  id: _index,
                  name: reasonList[_index]
                });
              }
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    queryEvent: function queryEvent() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.searchInfo.sdate = _this4.timedata[0];
              _this4.searchInfo.edate = _this4.timedata[1];
              _context3.next = 4;
              return goodsStatement(_this4.searchInfo);
            case 4:
              res = _context3.sent;
              // if (this.searchInfo.statement_type == 1) {
              //     this.optionLabel = "产出";
              // } else {
              //     this.optionLabel = "消耗";
              // }
              if (!res.data || res.data.count == 0) {
                _this4.tableData = [];
                _this4.$message({
                  message: "暂无数据",
                  type: "warning"
                });
              } else {
                _this4.tableData = res.data.list;
              }
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    exportBtn: function exportBtn() {
      this.searchInfo.sdate = this.timedata[0];
      this.searchInfo.edate = this.timedata[1];
      var url = "/api/xcpGameData/actionAnalysis/exportGoodsStatement?";
      this.exportCsv(url, this.searchInfo, "1");
    },
    openPop: function openPop() {
      this.$notify({
        title: "道具统计",
        dangerouslyUseHTMLString: true,
        message: "<div>（1）根据道具产出和消耗途径，统计当天的道具产出和消耗情况</div>" + "<div>（2）可以选择的查询条件包括日期范围（默认昨天）、更改类型（产出、消耗 | 单选）、vip等级（多选，默认全部）、服务器列表（多选，默认全部），道具名（多选，默认无）</div>" + "<div>（3）显示数据包括（日期 操作内容 更改类型 道具名 操作人数 操作次数 道具总数 人均消费 道具占比）</div>" + "<div>（4）操作内容对应游戏配置-》事件原因配置</div>" + "<div>（5）道具名对应游戏配置-》道具名配置</div>",
        duration: 0
      });
    }
  }
};